module.exports = __webpack_public_path__ + "img/development.d4aa8a25.svg";